import { tokens } from '@hotjar/hotsauce';

export const DEFAULT_UNDERLINE_HEIGHT = 2;

export const HOVERED_UNDERLINE_HEIGHT = 4;

export const FILTER_MATCH_TOOLTIP_COLOR = tokens.BRAND_COLORS.noon_400;

export const UNDERLINE_COLOR = FILTER_MATCH_TOOLTIP_COLOR;

export const TOOLTIP_AUTOHIDE_TIME = 5000;
